export class TaxTypeModel {
  public id: number = 0;
  public name: string = '';
  public rate: number = 0;
  public description: string = '';
  public isDefault: boolean = false;
  public isActive: boolean = true;
  public createdAt?: string;
  public updatedAt?: string;

  constructor(data: any = {}) {
    if (data && Object.keys(data).length > 0) {
      this.mapData(data);
    }
  }

  public mapData(data: any = {}) {
    this.id = data.id ?? 0;
    this.name = data.name || '';
    this.rate = data.rate ?? 0;
    this.description = data.description || '';
    this.isDefault = data.isDefault ?? data.is_default ?? false;
    this.isActive = data.isActive ?? data.is_active ?? true;
    this.createdAt = data.createdAt || data.created_at;
    this.updatedAt = data.updatedAt || data.updated_at;
  }
}
